"use client";
import { BdCloseCircle } from "solar-icon-react/bd";
import Logo from "../../logo";
import { buildHrefWithRawQuery, cn } from "@/lib";
import { FlexBetween, FlexCenter } from "@/components/ui/flexBox";
import { TFormMode } from "@/interfaces";
import { useTranslations } from "next-intl";
import { useModalStore } from "@/store";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import logo2 from "@public/svg/logo-2.svg";
import { routes } from "@/routes";

const AuthModalHeader = ({
  formMode,
  handleClose,
  isPage,
}: {
  formMode?: TFormMode;
  handleClose?: () => void;
  isPage?: boolean;
}) => {
  const { setOpenModal } = useModalStore();
  const t = useTranslations();
  const searchParams = useSearchParams();

  const switchModeLink = (formMode: TFormMode) => {
    switch (formMode) {
      case "otp":
        return !isPage ? (
          <span
            className="cursor-pointer text-sm md:text-base"
            title={t("authModalHeader.linkTitle")}
            onClick={() => {
              setOpenModal("login-by-pass-modal");
            }}
          >
            {t("authModalHeader.otpMode")}
          </span>
        ) : (
          <Link
            id="auth-modal-header-otp-mode"
            href={buildHrefWithRawQuery(
              routes.auth.LOGIN.primaryPath,
              searchParams,
            )}
          >
            {t("authModalHeader.otpMode")}
          </Link>
        );
      case "password":
        return !isPage ? (
          <span
            className="cursor-pointer"
            title={t("authModalHeader.linkTitle")}
            onClick={() => {
              setOpenModal("send-otp-modal");
            }}
          >
            {t("authModalHeader.passwordMode")}
          </span>
        ) : (
          <Link
            id="auth-modal-header-password-mode"
            href={buildHrefWithRawQuery(
              routes.auth.SEND_OTP.primaryPath,
              searchParams,
            )}
          >
            {t("authModalHeader.passwordMode")}
          </Link>
        );
    }
  };

  return (
    <div>
      <FlexBetween className="mb-2">
        {!!handleClose && (
          <BdCloseCircle
            className="text-primary-main! cursor-pointer"
            size={20}
            onClick={handleClose}
          />
        )}
        {formMode && (
          <FlexBetween className="h-10">
            <p
              className={cn(
                "text-primary-main mr-auto text-end text-xs sm:text-sm",
                isPage &&
                  "absolute top-6 left-3 sm:left-8 xl:top-10 xl:left-10",
              )}
            >
              {switchModeLink(formMode)}
            </p>
            {isPage && (
              <p
                className={cn(
                  "text-primary-main mr-auto text-end text-xs sm:text-sm",
                  isPage &&
                    "absolute top-6 right-3 sm:right-8 xl:top-10 xl:right-10",
                )}
              >
                <Link
                  id="auth-header-back-to-home"
                  href={routes.main.HOME.primaryPath}
                >
                  بازگشت به صفحه ی اصلی{" "}
                </Link>{" "}
              </p>
            )}
          </FlexBetween>
        )}
      </FlexBetween>
      <FlexCenter className={cn("mb-2")}>
        <Logo
          className="h-[60px] w-[60px] sm:h-[80px] sm:w-[80px] md:h-[100px] md:w-[100px]"
          src={logo2}
        />
      </FlexCenter>
      <h1
        className={cn(
          "text-primary-main text-md mb-2 text-center font-bold lg:mb-4 lg:text-xl",
        )}
      >
        {t("general.siteTitle")}
      </h1>
    </div>
  );
};
AuthModalHeader.Skeleton = () => (
  <div>
    <FlexBetween>
      <div className="h-5 w-5 rounded-full bg-gray-300"></div>
      <div className="h-4 w-24 rounded bg-gray-300"></div>
    </FlexBetween>
    <FlexCenter className="mb-2">
      <div className="h-12 w-32 rounded bg-gray-300"></div>
    </FlexCenter>
    <h1 className="mb-4 text-center text-xl font-bold">
      <div className="mx-auto h-6 w-3/4 rounded bg-gray-300"></div>
    </h1>
  </div>
);

export default AuthModalHeader;
